import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "./../../../components/Button/Button";
import { updatePage } from "./../../../services/pagesPersonnaliseesServices";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const EditPageModal = ({ isOpen, onClose, onSuccess, page }) => {
  const [formData, setFormData] = useState({
    titre: "",
    slug: "",
    introduction: "",
    actif: true,
  });

  useEffect(() => {
    if (page) {
      setFormData({
        titre: page.titre,
        slug: page.slug,
        introduction: page.introduction,
        actif: page.actif,
      });
    }
  }, [page]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleIntroductionChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      introduction: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedPage = {
        id: page.id,
        ...formData,
      };
      await updatePage(updatedPage);
      onSuccess();
      toast.success("Page mise à jour avec succès.");
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la page :", error);
      toast.error("Erreur lors de la mise à jour de la page.");
    }
  };

  const handleCancel = () => {
    onClose();
    if (page) {
      setFormData({
        titre: page.titre,
        slug: page.slug,
        introduction: page.introduction,
        actif: page.actif,
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-box bg-white p-4 rounded-lg shadow-lg dark:bg-gray-400 w-[500px]">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center text-white bg-primary rounded-md shadow">
          Modifier la Page
        </h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="titre"
            placeholder="Titre de la page"
            value={formData.titre}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          />
          <input
            type="text"
            name="slug"
            placeholder="Slug de la page"
            value={formData.slug}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          />
          <ReactQuill
            value={formData.introduction}
            onChange={handleIntroductionChange}
            className="mb-3"
          />
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="actif"
              checked={formData.actif}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  actif: e.target.checked,
                }))
              }
              className="form-checkbox text-primary"
            />
            <span className="text-gray-700">Page active</span>
          </label>
          <div className="flex justify-center space-x-2 mt-4">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={handleCancel}
              type="button"
              className="btn-ghost gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPageModal;
